import Logger, { EventName, LogLevel, ProviderType } from '@/wrappers/logger'

import { Query } from '../IDatabaseRead'

export const addErrorLog = ({
  channelId,
  error,
  context,
  query
}: {
  channelId: string
  error: Error
  context: string
  query: Query
}) => {
  Logger.addLog(
    EventName.FIRESTORE_ERROR,
    {
      modelId: channelId,
      data: {
        context,
        value: query,
        error
      }
    },
    {
      isAction: true,
      logLevel: LogLevel.ERROR
    },
    [ProviderType.DATADOG]
  )
}
